<template>
  <section id="products__product-display-section">
    <div class="products__main-title products__main-title--accessories">
      <h2>Accessories</h2>
    </div>
    <div
      v-if="accessories.length > 0"
      class="accessories__main-container">
      <accessory
        v-for="accessory in accessories"
        :key="accessory.ID"
        :accessory="accessory" />
    </div>

    <div
      v-else
      class="products__accessories-container-empty">
      <p>There are currently no accessories available, check back soon.</p>
    </div>
  </section>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import Accessory from '~/components/Accessory'
import head from '~/mixins/headerMetaData'

export default {
  components: {
    Accessory
  },
  mixins: [head],
  async asyncData (context) {
    const pageExists = context.store.getters['pages/doesPageExist']('home')
    if (pageExists) {
      const pageId = context.store.getters['pages/pageIdFromSlug']('home')
      let { data } = await context.$axios.get(`/api/pages/${pageId}`).catch((err) => {
        console.log(err)
      })
      if (data) {
        return {
          page: data,
          displayModal: false
        }
      }
    } else {
      // If no page exists set the ID to false
      return {
        page: {
          ID: false,
          displayModal: false
        }
      }
    }
  },
  computed: {
    ...mapGetters('products', {
      accessories: 'accessories'
    })
  },
  methods: {
    ...mapMutations({
      increment: 'increment'
    })
  }
}
</script>

<style lang="scss" scoped>
#products__product-display-section {
  padding: 57px 45px;

  .vertical-divider {
    width: 1px;
    background-color: $grey;
    height: 100%;
    margin: 0 auto;
    position: absolute;
    left: 50%;

    @media screen and (max-width: 650px) {
      display: none;
    }
  }

  @media screen and (max-width: 650px) {
    padding: 40px 15px;
  }

  @media screen and (max-width: 460px) {
    padding-bottom: 0;
  }
}

.products {
  @include e('main-title') {
    max-width: 1110px;
    margin: 0 auto 0px;
    padding: 0px 15px 0px;

    h2 {
      font-size: 45px;
      margin: 0px 0px 0px;
      padding-bottom: 15px;
      line-height: 1em;
      border-bottom: solid 1px #CCC;

      @media screen and (max-width:800px) {
        font-size: 35px;
      }
    }

    @include m('accessories') {
      margin: 7px auto 7px;
    }
  }

  @include e('title') {
    font-size: 28px;
    margin: 15px 0 10px;
    padding-bottom: 10px;
  }

  @include e('accessories-container-empty') {
    width: 80%;
    margin: 0 auto;
    text-align: center;
  }
}

.accessories {

  @include e('main-container') {
    width: 100%;
    max-width: 1110px;
    padding: 0 45px;
    margin: auto;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;

    @media screen and (max-width: 850px) {
      padding: 0px 30px;
    }
  }
}
</style>
